<template>
  <div
    v-show="show"
    class="dropdown-menu-clir container p-0 "
    role="list"
    :aria-labelledby="computedId"
  >
    <div :class="dropdownMenuClass">
      <div class="row">
        <!-- sur chaque child, soit on a un sous menu soit on a un lien -->
        <div
          v-for="(subpage,sindex) in children"
          :key="sindex"
          :class="getSubpageContainerClass(subpage)"
        >
          <div role="listitem">
            <ul v-if="!getKey(subpage,'children',[]).length" :class="listgroupClass">
              <ApplicationMenuDropdownItem v-bind="subpage" @tabulated="$emit('tabulated',$event)" />
            </ul>
            <div v-else>
              <p
                v-if="subpage.subtitle !== undefined"
                class="list-header"
                href="#"
              >{{subpage.subtitle }}</p>
              <ul :class="listgroupClass">
                <ApplicationMenuDropdownItem
                  v-for="(subchild,subindex) in subpage.children"
                  :key="subindex"
                  v-bind="subchild"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ApplicationMenuDropdownItem from "@clir/ApplicationMenu/ApplicationMenuDropdownItem";
export default {
  name: "ApplicationMenuDropdownMenu",
  props: {
    name: { type: String, default: "" },
    title: { type: String, default: "" },
    textClass: { type: String, default: "" },
    linkTheme: { type: String, default: "" },
    children: {
      type: Array,
      default: function() {
        return [];
      }
    },
    childrenMenuTheme: {
      type: Object,
      default: function() {
        return {
          background: "",
          text: ""
        };
      }
    },
    show: { type: Boolean, default: false }
  },
  computed: {
    dropdownMenuClass() {
      return `${this.prefixStringKey(this.childrenMenuTheme, "background", {
        prefix: "container px-4 bg-",
        defaut: "container px-4"
      })} ${this.prefixStringKey(this.childrenMenuTheme, "text", {
        prefix: "text-"
      })}`;
    },
    listgroupClass() {
      let txtclass = this.prefixStringKey(this.childrenMenuTheme, "text", {
        prefix: "list-group-bulleted-"
      });
      if (!txtclass.length) txtclass = this.textClass;
      return `list-group list-group-condensed list-group-bulleted ${txtclass}`;
    },
    computedId() {
      return `navbarDropdown${this.name.length ? this.name : this.title}`;
    },
    displayedTitle() {
      return this.title.length ? this.title : this.name;
    }
  },
  methods: {
    getSubpageContainerClass(subpage) {
      return this.getKey(subpage, "containerClass", "col-md-12");
    }
  },
  components: { ApplicationMenuDropdownItem }
};
</script>
<style scoped>
.dropdown-menu-clir {
  width: 100% !important;
  background-color: transparent !important;
  z-index: 1000 !important;
}
.dropdown-menu-clir .list-header {
  margin: 0.5rem 0;
  font-weight: 600;
  color: inherit;
}
</style>